module.exports = __webpack_public_path__ + "img/felc_cer_new.ca3b97c5.jpg";